import styled from 'styled-components';

const CountryUsers = styled.small`
  color: ${({ theme }) => theme?.colors?.textSecondary || '#888'};

  @media (max-width: ${({ theme }) => theme?.breakpoints?.mobile || '768px'}) {
    font-size: 0.75rem;
  }
`;

export default CountryUsers;
